import { ActividadCronograma, Area, AreaCategoria, CategoriaArea, Categorias, Ciclo, Criterios, DocumentoAdministrativo, DocumentoTecnico, Entidad, LineaConvocatoria, LineaEstrategica, PostDocumentoAdministrativo } from "../../models/Maestras/maestras.model";
import { BaseMaestrasService } from "../base/baseMaestrasApi";

export class MaestrasService extends BaseMaestrasService {
    async crearLineaConvocatoria( lineaConvocatoria: LineaConvocatoria ) {
        try {
            const { data } = await this.axiosClient.post(`/LineasConovcatorias`, lineaConvocatoria);
            return data;
        } catch (error) {
            throw new Error(`An unhandled exception in postConvocatoria with stack: ${error}`);
        }
    }

    async crearCategoriasPorLinea ( categorias: Categorias ) {
        try {
            const { data } = await this.axiosClient.post(`/categoriaLineaConvocatorias`, categorias);
            return data.data;
        } catch (error) {
            throw new Error(`An unhandled exception in postConvocatoria with stack: ${error}`);
        }
    }

    async obtenerLineaConvocatoria () {
        try {
            const { data } = await this.axiosClient.get(`/LineasConovcatorias`);
            return Array.isArray(data) ? data : (data?.data || []);
        } catch (error) {
            console.warn("No se pudieron obtener las líneas de convocatoria del servidor:", error);
            return [];
        }
    }

    async obtenerCategorias ( ) {
        try {
            const { data } = await this.axiosClient.get(`/categoriaLineaConvocatorias`);
            return data;
        } catch (error) {
            throw new Error(`An unhandled exception in obtenerCategoriasPorLinea with stack: ${error}`);
        }
    }


    async obtenerCategoriasPorLinea ( id?: number ) {
        try {
            const { data } = await this.axiosClient.get(`/categoriaLineaConvocatorias/${id}`);
            return data;
        } catch (error) {
            throw new Error(`An unhandled exception in obtenerCategoriasPorLinea with stack: ${error}`);
        }
    }

    async actualizarCategoria ( datosCategoria: Categorias ) {
        try {
            const { data } = await this.axiosClient.put(`/categoriaLineaConvocatorias/${datosCategoria.id}`, datosCategoria);
            return data;
        } catch (error) {
            throw new Error(`An unhandled exception in actualizarCategoria with stack: ${error}`);
        }
    }

    async eliminarCategoria ( id: any ) {
        try {
            const { data } = await this.axiosClient.delete(`/categoriaLineaConvocatorias/${id}`);
            return data;
        } catch (error) {
            throw new Error(`An unhandled exception in eliminarCategoria with stack: ${error}`);
        }
    }

    async actualizarLineaConvocatoria( lineaConvocatoria: any ) {
        try {
            const { data } = await this.axiosClient.put(`/LineasConovcatorias/${lineaConvocatoria.id}`, lineaConvocatoria);
            return data;
        } catch (error) {
            throw new Error(`An unhandled exception in actualizarLineaConvocatoria with stack: ${error}`);
        }
        
    }

    async eliminarLineaConvocatoria( id_linea: any ) {
        try {
            const { data } = await this.axiosClient.delete(`/LineasConovcatorias/${id_linea}`);
            return data;
        } catch (error) {
            throw new Error(`An unhandled exception in actualizarLineaConvocatoria with stack: ${error}`);
        }
        
    }

    async obtenerActividadesCronograma() : Promise <ActividadCronograma[]> {
        try {
            const { data } = await this.axiosClient.get(`/actividades`);
            return data;
        } catch (error) {
            throw new Error(`An unhandled exception in obtenerActividadesCronograma with stack: ${error}`);
        }
    }

    async crearActividadCronograma( actividadCronograma: ActividadCronograma ) {
        try {
            const { data } = await this.axiosClient.post(`/actividades`, actividadCronograma);
            return data;
        } catch (error) {
            throw new Error(`An unhandled exception in crearActividadCronograma with stack: ${error}`);
        }
    }

    async actualizarActividadCronograma( actividadCronograma: ActividadCronograma ) {
        try {
            const { data } = await this.axiosClient.put(`/actividades/${actividadCronograma.id}`, actividadCronograma);
            return data;
        } catch (error) {
            throw new Error(`An unhandled exception in actualizarActividadCronograma with stack: ${error}`);
        }
    }
    
    async eliminarActividadCronograma( id: number ) {
        try {
            const { data } = await this.axiosClient.delete(`/actividades/${id}`);
            return data;
        } catch (error) {
            throw new Error(`An unhandled exception in eliminarActividadCronograma with stack: ${error}`);
        }
    }


    async obtenerDocumentosAdminsitrativos() : Promise <DocumentoAdministrativo[]> {
        try {
            const { data } = await this.axiosClient.get(`/documentos_administrativos`);
            return data.data;
        } catch (error) {
            throw new Error(`An unhandled exception in obtenerDocumentosAdminsitrativos with stack: ${error}`);
        }
    }

    async crearDocumentoAdministrativo( documentoAdministrativo : PostDocumentoAdministrativo )  {
        try {
            const { data } = await this.axiosClient.post(`/documentos_administrativos`, documentoAdministrativo);
            return data;
        } catch (error) {
            throw new Error(`An unhandled exception in crearDocumentoAdministrativo with stack: ${error}`);
        }
    }
    
    async actualizarDocumentoAdministrativo( documentoAdministrativo : DocumentoAdministrativo )  {
        try {
            const { data } = await this.axiosClient.put(`/documentos_administrativos/${documentoAdministrativo.id}`, documentoAdministrativo);
            return data;
        } catch (error) {
            throw new Error(`An unhandled exception in crearDocumentoAdministrativo with stack: ${error}`);
        }
    }
    async eliminarDocumentoAdministrativo( id : number )  {
        try {
            const { data } = await this.axiosClient.delete(`/documentos_administrativos/${id}`);
            return data;
        } catch (error) {
            throw new Error(`An unhandled exception in crearDocumentoAdministrativo with stack: ${error}`);
        }
    }

    async obtenerDocumentosTecnicos() : Promise<DocumentoTecnico[]> {
        try {
            const { data } = await this.axiosClient.get(`/documentos_tecnicos`);
            return data;
        } catch (error) {
            throw new Error(`An unhandled exception in obtenerDocumentosTecnicos with stack: ${error}`);
        }
    }

    async crearDocumentoTecnico( documento_tecnico: DocumentoTecnico) {
        try {
            const { data } = await this.axiosClient.post(`/documentos_tecnicos`, documento_tecnico);
            return data;
        } catch (error) {
            throw new Error(`An usnhandled exception in crearDocumentoTecnico with stack: ${error}`);
        }
    }

    async actualizarDocumentoTecnico( documento_tecnico: DocumentoTecnico) {
        try {
            const { data } = await this.axiosClient.put(`/documentos_tecnicos/${documento_tecnico.id}`, documento_tecnico);
            return data;
        } catch (error) {
            throw new Error(`An unhandled exception in crearDocumentoTecnico with stack: ${error}`);
        }
    }
    async eliminarDocumentoTecnico( id?: number ) {
        try {
            const { data } = await this.axiosClient.delete(`/documentos_tecnicos/${id}`);
            return data;
        } catch (error) {
            throw new Error(`An unhandled exception in eliminarDocumentoTecnico with stack: ${error}`);
        }
    }

    async obtenerEntidades() : Promise<Entidad[]> {
        try {
            const { data } = await this.axiosClient.get(`/entidad`);
            return data;
        } catch (error) {
            throw new Error(`An unhandled exception in obtenerDocumentosTecnicos with stack: ${error}`);
        }
    }

    async crearEntidad( entidad: Entidad) {
        try {
            const { data } = await this.axiosClient.post(`/entidad`, entidad);
            return data;
        } catch (error) {
            throw new Error(`An unhandled exception in crearDocumentoTecnico with stack: ${error}`);
        }
    }

    async actualizarEntidad( entidad: Entidad){
        try {
            const { data } = await this.axiosClient.put(`/entidad/${entidad.id}`, entidad);
            return data;
        } catch (error) {
            throw new Error(`An unhandled exception in crearDocumentoTecnico with stack: ${error}`);
        }
    }
    async eliminarEntidad( id?: number ) {
        try {
            const { data } = await this.axiosClient.delete(`/entidad/${id}`);
            return data;
        } catch (error) {
            throw new Error(`An unhandled exception in eliminarDocumentoTecnico with stack: ${error}`);
        }
    }
    

    async obtenerCiclos() : Promise<Ciclo[]> {
        try {
            const { data } = await this.axiosClient.get(`/ciclos`);
            return data;
        } catch (error) {
            throw new Error(`An unhandled exception in obtenerCiclos with stack: ${error}`);
        }
    }

    async crearCiclo( ciclo: Ciclo) {
        try {
            const { data } = await this.axiosClient.post(`/ciclos`, ciclo);
            return data;
        } catch (error) {
            throw new Error(`An unhandled exception in crearCiclo with stack: ${error}`);
        }
    }

    async actualizarCiclo( ciclo: Ciclo) {
        try {
            const { data } = await this.axiosClient.put(`/ciclos/${ciclo.id}`, ciclo);
            return data;
        } catch (error) {
            throw new Error(`An unhandled exception in actualizarCiclo with stack: ${error}`);
        }
    }
    async eliminarCiclo( id?: number ) {
        try {
            const { data } = await this.axiosClient.delete(`/ciclos/${id}`);
            return data;
        } catch (error) {
            throw new Error(`An unhandled exception in eliminarCiclo with stack: ${error}`);
        }
    }


    async obtenerAreas() : Promise<Area[]> {
        try {
            const { data } = await this.axiosClient.get(`/areas`);
            return data;
        } catch (error) {
            throw new Error(`An unhandled exception in obtenerAreas with stack: ${error}`);
        }
    }

    async crearArea( area: Area) {
        try {
            const { data } = await this.axiosClient.post(`/areas`, area);
            return data;
        } catch (error) {
            throw new Error(`An unhandled exception in crearArea with stack: ${error}`);
        }
    }

    async actualizarArea( area: Area) {
        try {
            const { data } = await this.axiosClient.put(`/areas/${area.id}`, area);
            return data;
        } catch (error) {
            throw new Error(`An unhandled exception in actualizarArea with stack: ${error}`);
        }
    }
    async eliminarArea( id?: number ) {
        try {
            const { data } = await this.axiosClient.delete(`/areas/${id}`);
            return data;
        } catch (error) {
            throw new Error(`An unhandled exception in eliminarArea with stack: ${error}`);
        }
    }
    
    async obtenerLineaEstrategicas() : Promise<LineaEstrategica[]> {
        try {
            const { data } = await this.axiosClient.get(`/lineaEstrategica`);
            return data;
        } catch (error) {
            throw new Error(`An unhandled exception in obtenerLineaEstrategicas with stack: ${error}`);
        }
    }

    async crearLineaEstrategica( linea_estrategica: LineaEstrategica) {
        try {
            const { data } = await this.axiosClient.post(`/lineaEstrategica`, linea_estrategica);
            return data;
        } catch (error) {
            throw new Error(`An unhandled exception in crearLineaEstrategica with stack: ${error}`);
        }
    }

    async actualizarLineaEstrategica( linea_estrategica: LineaEstrategica) {
        try {
            const { data } = await this.axiosClient.put(`/lineaEstrategica/${linea_estrategica.id}`, linea_estrategica);
            return data;
        } catch (error) {
            throw new Error(`An unhandled exception in actualizarLineaEstrategica with stack: ${error}`);
        }
    }
    async eliminarLineaEstrategica( id?: number ) {
        try {
            const { data } = await this.axiosClient.delete(`/lineaEstrategica/${id}`);
            return data;
        } catch (error) {
            throw new Error(`An unhandled exception in eliminarLineaEstrategica with stack: ${error}`);
        }
    }


    async obtenerAreasCategorias() : Promise<AreaCategoria[]> {
        try {
            const { data } = await this.axiosClient.get(`/areasCategorias`);
            return data;
        } catch (error) {
            throw new Error(`An unhandled exception in obtenerAreasCategorias with stack: ${error}`);
        }
    }

    async crearAreasCategorias( area_categoria: AreaCategoria)  {
        try {
            const { data } = await this.axiosClient.post(`/areasCategorias`, area_categoria);
            return data;
        } catch (error) {
            throw new Error(`An unhandled exception in crearAreasCategorias with stack: ${error}`);
        }
    }

    async crearCategoriaArea( categoria: CategoriaArea)  {
        try {
            const { data } = await this.axiosClient.post(`/categorias`, categoria);
            return data;
        } catch (error) {
            throw new Error(`An unhandled exception in crearAreasCategorias with stack: ${error}`);
        }
    }

    async obtenerCategoriasAreas( id?: number)  {
        try {
            const { data } = await this.axiosClient.get(`/categorias/${id}`);
            return data;
        } catch (error) {
            throw new Error(`An unhandled exception in obtenerAreasCategorias with stack: ${error}`);
        }
    }


    async actualizarCategoriasAreas( datosCategoria: CategoriaArea )  {
        try {
            const { data } = await this.axiosClient.put(`/categorias/${datosCategoria.id}`, datosCategoria);
            return data;
        } catch (error) {
            throw new Error(`An unhandled exception in actualizarCategoriasAreas with stack: ${error}`);
        }
    }

    async eliminarCategoriasAreas( id: number )  {
        try {
            const { data } = await this.axiosClient.delete(`/categorias/${id}`);
            return data;
        } catch (error) {
            throw new Error(`An unhandled exception in actualizarCategoriasAreas with stack: ${error}`);
        }
    }

    async actualizarAreasCategorias( area_categoria: AreaCategoria)  {
        try {
            const { data } = await this.axiosClient.put(`/areasCategorias/${area_categoria.id_area}`, area_categoria);
            return data;
        } catch (error) {
            throw new Error(`An unhandled exception in crearAreasCategorias with stack: ${error}`);
        }
    }


    async eliminarAreasCategorias( id: number )  {
        try {
            const { data } = await this.axiosClient.delete(`/areasCategorias/${id}`);
            return data;
        } catch (error) {
            throw new Error(`An unhandled exception in crearAreasCategorias with stack: ${error}`);
        }
    }

    async obtenerCriterios() : Promise<Criterios[]>  {
        try {
            const { data } = await this.axiosClient.get(`/criterios`);
            return data;
        } catch (error) {
            throw new Error(`An unhandled exception in obtenerCriterios with stack: ${error}`);
        }
    }

    async crearCriterio( criterio: Criterios){
        try {
            const { data } = await this.axiosClient.post(`/criterios`, criterio);
            return data;
        } catch (error) {
            throw new Error(`An unhandled exception in crearCriterio with stack: ${error}`);
        }
    }

    async actualizarCriterio( criterio: Criterios) : Promise<Criterios> {
        try {
            const { data } = await this.axiosClient.put(`/criterios/${criterio.id}`, criterio);
            return data;
        } catch (error) {
            throw new Error(`An unhandled exception in actualizarCriterio with stack: ${error}`);
        }
    }
    async eliminarCriterio( id?: number ) {
        try {
            const { data } = await this.axiosClient.delete(`/criterios/${id}`);
            return data;
        } catch (error) {
            throw new Error(`An unhandled exception in eliminarCriterio with stack: ${error}`);
        }
    }

    async obtenerAreasConCategorias() {
        try {
            const { data } = await this.axiosClient.get(`/areasCategorias/obtenerAreasConCategorias/`);
            return data;
        } catch (error) {
            throw new Error(`An unhandled exception in eliminarCriterio with stack: ${error}`);
        }
    }

    async obtenerDocGen() {
        try {
            const { data } = await this.axiosClient.get(`/documentos_generales`);
            return data;
        } catch (error) {
            throw new Error(`An unhandled exception in obtenerDocGen with stack: ${error}`);
        }
    }

    async searchCriteria(nombre: string) {
        try {
            const { data } = await this.axiosClient.post(`/criterios/search`, {nombre});
            return data;
        } catch (error) {
            throw new Error(`An unhandled exception in obtenerDocGen with stack: ${error}`);
        }
    }

    async obtenerLineasConConvocatorias() {
        try {
            const { data } = await this.axiosClient.get(`/LineasConovcatorias/obtenerLineasConCategorias`);
            return data;
        } catch (error) {
            throw new Error(`An unhandled exception in obtenerDocGen with stack: ${error}`);
        }
    }


    
}

export default new MaestrasService();